<div class="laheta-card">
  <div class="autosave-time">{{ autosaveTimeTextObservable | async }}</div>
  <div class="laheta-title light-blue-text">
    Lähetä asiakkaalle sähköposti
    <!-- <button style="margin-left: 20px;" (click)="_resetAutosave()">Poista tietokannasta</button> -->
  </div>
  <div class="laheta-body">
    <form>
      <div style="margin: 0 10px">
        @if (vastaanottajat?.length) {
          <div>
            <mat-form-field style="margin-bottom: 15px">
              <mat-label>Vastaanottajat</mat-label>
              <input type="text" [formField]="lomake.vastaanottajat" matInput data-lpignore="true" autocomplete="jokuihantajutonjutthei" />
            </mat-form-field>
          </div>
        } @else {
          <div style="color: #f44336; margin-bottom: 2em; margin-left: 10px">
            <div style="font-weight: bold">Ei vastaanottajia.</div>
            <div style="font-size: 13px">
              (Lisää käyttäjä, jolla on Yhteyshenkilö-rooli, navigoimalla <a [routerLink]="['/asiakkaat', asiakasAvain, 'kayttajat']">Lemonaid -> Käyttäjät</a>. Varmista, että Aktiivinen-täppä on päällä. Vaihtoehtoisesti voit käyttää yleistä vastaanotto-osoittetta, lisää sellainen
              <a [routerLink]="['/asiakkaat', asiakasAvain, 'kirjanpitotiedot']">Asetukset -> Kirjanpito -> Kirjanpitosähköpostien lisävastaanottajat</a>)
            </div>
          </div>
        }
        <div style="display: flex; justify-content: space-between; margin-top: -10px; margin-bottom: -10px">
          <mat-form-field style="margin-bottom: 15px; width: 420px">
            <mat-label>Lähettäjä</mat-label>
            <input type="email" [formField]="lomake.lahettaja" matInput data-lpignore="true" autocomplete="jokuihantajutonjutthei" />
          </mat-form-field>
          <mat-checkbox style="margin-top: 10px" [formField]="lomake.piilokopioLahettajalle">Piilokopio lähettäjälle</mat-checkbox>
        </div>
        <mat-form-field style="margin-bottom: 15px">
          <mat-label>Aihe</mat-label>
          <input (blur)="tryAutosave()" [formField]="lomake.aihe" matInput data-lpignore="true" autocomplete="jokuihantajutonjutthei" class="email-aihe" />
          <!-- <button mat-icon-button matSuffix (click)="resetAihe()" title="Palauta alkuperäinen teksti">
        <mat-icon>settings_backup_restore</mat-icon>
      </button> -->
          @if (onkoVirhe(lomake.aihe, 'required') && (lomake.aihe().dirty() || lomake.aihe().touched())) {
            <mat-error> Lisää aihe. </mat-error>
          }
        </mat-form-field>
        <div style="margin: 10px -20px 10px -20px; padding: 20px 20px 0 20px; border: 2px solid rgb(217, 217, 217)">
          <mat-form-field class="no-outline no-margin">
            <textarea #tekstiTextareaAlku (blur)="tryAutosave()" tahtiOhjeeseen [formField]="lomake.tekstinAlku" matInput data-lpignore="true" matInput cdkTextareaAutosize #autosizeAlku="cdkTextareaAutosize" [cdkAutosizeMinRows]="1" placeholder="Teksti 1"></textarea>
            <!-- <button mat-icon-button matSuffix (click)="resetTeksti1()" title="Palauta alkuperäinen teksti">
        <mat-icon>settings_backup_restore</mat-icon>
      </button> -->
            @if (onkoVirhe(lomake.tekstinAlku, 'required') && (lomake.tekstinAlku().dirty() || lomake.tekstinAlku().touched())) {
              <mat-error> Lisää teksti. </mat-error>
            }
          </mat-form-field>
          <div class="autotext">
            <div [style.display]="includeMainAutotext ? 'block' : 'none'" [innerHTML]="mainAutotext"></div>
            <app-button
              [title]="includeMainAutotext ? 'Poista automaattisesti luotu teksti sähköpostista' : 'Lisää automaattisesti luotu teksti sähköpostiin'"
              (click)="showOrHideMainAutotext()"
              actionId="Poista / Lisää automaattisesti luotu pääteksti sähköpostiin (kirjanpito lähetys)"
              styles="position: absolute; top: 0px; right: 0px; margin: 0; line-height: 28px; min-width: 28px; font-size: 24px; padding: 0;"
            >
              {{ includeMainAutotext ? 'x' : '+' }}
            </app-button>
          </div>

          <div class="autotext">
            <div [style.display]="includeSelvitettavatAutotext ? 'block' : 'none'" [innerHTML]="selvitettavatAutotext"></div>
            <app-button
              [title]="includeSelvitettavatAutotext ? 'Poista automaattisesti luotu teksti sähköpostista' : 'Lisää automaattisesti luotu teksti sähköpostiin'"
              (click)="showOrHideSelvitettavatAutotext()"
              actionId="Poista / Lisää automaattisesti luotu teksti sähköpostiin (selvitettävät)"
              styles="position: absolute; top: 0px; right: 0px; margin: 0; line-height: 28px; min-width: 28px; font-size: 24px; padding: 0;"
            >
              {{ includeSelvitettavatAutotext ? 'x' : '+' }}
            </app-button>
          </div>

          <mat-form-field class="no-outline no-margin">
            <textarea #tekstiTextareaLoppu (blur)="tryAutosave()" tahtiOhjeeseen [formField]="lomake.tekstinLoppu" placeholder="Teksti 2" matInput data-lpignore="true" matInput cdkTextareaAutosize #autosizeLoppu="cdkTextareaAutosize" [cdkAutosizeMinRows]="4"></textarea>
            <!-- <button mat-icon-button matSuffix (click)="resetTeksti2()" title="Palauta alkuperäinen teksti">
      <mat-icon>settings_backup_restore</mat-icon>
    </button> -->
            @if (onkoVirhe(lomake.tekstinLoppu, 'required') && (lomake.tekstinLoppu().dirty() || lomake.tekstinLoppu().touched())) {
              <mat-error> Lisää teksti. </mat-error>
            }
          </mat-form-field>
          <div app-kirjanpito-lahetys-signature [kirjanpitajanNimitiedot]="nykyisenKirjanpitajanNimitiedotObservable | async" [kieli]="asiakkaanKieliObservable | async"></div>
        </div>
        Liitteet
        <div class="check-wrapper">
          <div style="display: flex; flex-direction: row">
            <mat-checkbox class="liitteet-list-item" [formField]="lomake.tuloslaskelma">Tuloslaskelma</mat-checkbox>
            <app-button (click)="downloadTulos()" actionId="Lataa tuloslaskelma koneelle (kirjanpitopostin lähetys)" additionalClass="lataa-pdf-button light-blue-text">
              <i class="fa fa-file-pdf-o"></i>
            </app-button>
          </div>
          <div style="display: flex; flex-direction: row; margin-top: -7px">
            <mat-checkbox class="liitteet-list-item" [formField]="lomake.tase">Tase</mat-checkbox>
            <app-button (click)="downloadTase()" actionId="Lataa tase koneelle (kirjanpitopostin lähetys)" additionalClass="lataa-pdf-button light-blue-text">
              <i class="fa fa-file-pdf-o"></i>
            </app-button>
          </div>
          <div style="display: flex; flex-direction: row; margin-top: -7px">
            <mat-checkbox class="liitteet-list-item" [formField]="lomake.paakirja">Pääkirja</mat-checkbox>
            <app-button (click)="downloadPaakirja()" actionId="Lataa pääkirja koneelle (kirjanpitopostin lähetys)" additionalClass="lataa-pdf-button light-blue-text">
              <i class="fa fa-file-pdf-o"></i>
            </app-button>
          </div>
          <div style="display: flex; flex-direction: row">
            <mat-checkbox class="liitteet-list-item" [formField]="lomake.alvIlmoitus">ALV-ilmoitus</mat-checkbox>
            <app-button (click)="downloadAlvIlmoitus()" actionId="Lataa alv-ilmoitus koneelle (kirjanpitopostin lähetys)" additionalClass="lataa-pdf-button light-blue-text">
              <i class="fa fa-file-pdf-o"></i>
            </app-button>
          </div>
          <div style="display: flex; flex-direction: row; margin-top: -7px">
            <mat-checkbox class="liitteet-list-item" [formField]="lomake.selvitettavatOstot">Selvitettävät ostot</mat-checkbox>
            <app-button (click)="downloadSelvitettavatOstot()" actionId="Lataa selvitettävät ostot koneelle (kirjanpitopostin lähetys)" additionalClass="lataa-pdf-button light-blue-text">
              <i class="fa fa-file-pdf-o"></i>
            </app-button>
          </div>
          <div style="display: flex; flex-direction: row; margin-top: -7px">
            <mat-checkbox class="liitteet-list-item" [formField]="lomake.selvitettavatMyynnit">Selvitettävät myynnit</mat-checkbox>
            <app-button (click)="downloadSelvitettavatMyynnit()" actionId="Lataa selvitettävät myynnit koneelle (kirjanpitopostin lähetys)" additionalClass="lataa-pdf-button light-blue-text">
              <i class="fa fa-file-pdf-o"></i>
            </app-button>
          </div>
        </div>
        <div class="attachment-wrapper">
          @for (liite of emailLiitteetObservable | async; track liite) {
            <div class="attachment-row">
              <app-icon-button (click)="deleteAttachment(liite)" actionId="Poista liite sähköpostin lähetyksestä (kirjanpitopostin lähetys)" additionalClass="remove-btn small-icon-button">
                <i class="icon ion-ios-trash icon-btn"></i>
              </app-icon-button>
              <div class="attachment-text">{{ liite.nimi }}</div>
              <div class="attachment-size">{{ liite.koko > 100 * 1000 ? (liite.koko / (1000 * 1000) | ldecimall: 1 : 'fi') : (liite.koko / (1000 * 1000) | ldecimall: 3 : 'fi') }} MT</div>
              <app-icon-button (click)="downloadAttachment(liite)" actionId="Lataa liite koneelle (kirjanpitopostin lähetys)" additionalClass="lataa-pdf-button small-icon-button">
                <i class="fa fa-file-pdf-o"></i>
              </app-icon-button>
            </div>
          }
        </div>

        <app-button (click)="fileInput.click()" actionId="Valitse tiedosto: Lisää liitetiedosto (kirjanpitopostin lähetys)"> + Lisää liitetiedosto </app-button>
        @if (latausVirhe) {
          <div class="error-box">{{ latausVirhe }}</div>
        }
      </div>
    </form>
    @if (attachmentsTotalSizeIfTooBigObservable | async; as totalSize) {
      <div class="error-msg">Sähköpostin liitteiden kokonaiskoko ei saa ylittää 10 MT (Nykyinen koko: {{ totalSize }} MT)</div>
    }

    <div style="display: flex; justify-content: space-evenly; padding-top: 20px">
      <app-primary-button (click)="laheta()" [disabled]="(attachmentsTotalSizeIfTooBigObservable | async) > 0" actionId="Lähetä kirjanpidon sähköposti" [actionContext]="[lahetyksenArvot()]"> Lähetä </app-primary-button>
    </div>
  </div>
</div>

<!-- <button mat-button (click)="reload()" type="button">
TYHJENNÄ TÄSTÄ
</button> -->

<!-- <div app-kirjanpito-lahetys-alv [valittuKuukausiObservable]="valittuKuukausiObservable" [latestAlvIlmoitusObservable]="alvIlmoitusObservable" [naytaAlvIlmoitusValilehtiObservable]="naytaAlvIlmoitusValilehtiObservable" [erapaivaObservable]="erapaivaObservable"></div> -->
<div>
  <div style="margin: 0.5em; padding: 2em 0 1em 0" class="light-blue-text laheta-title">Asiakkaalle lähetetyt sähköpostit</div>

  @if (historyLoading) {
    <div style="display: flex; height: 200px; justify-content: center; align-items: center">
      <mat-spinner mode="indeterminate"></mat-spinner>
    </div>
  }
  @if (!sentThisMonth?.length && !historyLoading) {
    <div style="margin-left: 35px">Asiakkaalle ei ole vielä lähetetty sähköposteja tässä kuussa.</div>
  }

  @for (item of sentThisMonth; track item) {
    <div class="laheta-card">
      <div class="laheta-body laheta-body-history">
        @if (item.firestoreLinkki) {
          <div style="padding: 10px; margin-bottom: 30px; position: relative" class="mat-elevation-z2">
            <span style="font-size: 10px; position: absolute; top: 3px; right: 5px" class="light-gray-text">(Vain devaajat)</span>
            <h3 style="margin: 0">Urit</h3>
            <div style="padding-top: 1em; padding-left: 1em; padding-right: 1em">
              Lähetetty email: <a [href]="item.firestoreLinkkiEncoded" target="_BLANK">{{ item.firestoreLinkki }}</a>
            </div>
          </div>
        }
        <mat-form-field style="margin-bottom: 15px">
          <mat-label>Vastaanottajat</mat-label>
          <input disabled="true" type="text" [value]="item.recipientsEmails" matInput />
        </mat-form-field>
        <mat-form-field style="margin-bottom: 15px">
          <mat-label>Aihe</mat-label>
          <input disabled="true" type="text" [value]="item.aihe" matInput />
        </mat-form-field>
        <div class="history-text">
          <span class="history-text-label">Teksti</span>
          <div [innerHTML]="item.teksti"></div>
        </div>
        @if (item.liitaAlvIlmoitus || item.liitaSelvitettavatOstot || item.liitaSelvitettavatMyynnit || item.liitaTase || item.liitaTuloslaskelma || item.liitaPaakirja || item.liitteet.length) {
          <div style="margin-top: 10px">
            <span style="color: grey">Liitteet</span>
            <div class="history-liite-wrapper">
              @if (item.liitaTuloslaskelma) {
                <li class="history-liite" (click)="downloadSentReport(item.avain, 'tuloslaskelma')">tuloslaskelma.pdf</li>
              }
              @if (item.liitaTase) {
                <li class="history-liite" (click)="downloadSentReport(item.avain, 'tase')">tase.pdf</li>
              }
              @if (item.liitaPaakirja) {
                <li class="history-liite" (click)="downloadSentReport(item.avain, 'paakirja')">paakirja.pdf</li>
              }
              @if (item.liitaAlvIlmoitus) {
                <li class="history-liite" (click)="downloadSentReport(item.avain, 'alv-ilmoitus')">alv-ilmoitus.pdf</li>
              }
              @if (item.liitaSelvitettavatOstot) {
                <li class="history-liite" (click)="downloadSentReport(item.avain, 'selvitettavat-ostot')">selvitettavat-ostot.pdf</li>
              }
              @if (item.liitaSelvitettavatMyynnit) {
                <li class="history-liite" (click)="downloadSentReport(item.avain, 'selvitettavat-myynnit')">selvitettavat-myynnit.pdf</li>
              }
              @for (liite of item.liitteet; track liite) {
                <li class="history-liite" (click)="downloadAttachment(liite)">
                  {{ liite.nimi }}
                  @if (liite.firestoreLinkki) {
                    <a [href]="liite.firestoreLinkkiEncoded" onclick="event.stopPropagation()" target="_BLANK">{{ liite.firestoreLinkki }}</a>
                  }
                </li>
              }
            </div>
          </div>
        }
      </div>
      <div class="history-title light-blue-text">{{ item.nimi }} {{ item.luotuDateStr }}</div>
    </div>
  }
  <!-- <ng-container #noHistory class="history-title light-blue-text"></ng-container> -->
</div>

<input #fileInput type="file" style="visibility: hidden" accept="*" multiple (change)="lataa($event)" />
